import {FC} from 'react';
import { CheckboxProps } from '../../../interfaces';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel
} from '@material-ui/core';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import { useField, useFormikContext } from 'formik';

const CheckboxWrapper:FC<CheckboxProps> = ({
  name,
  label,
  color,
  error,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (evt: { target: { checked: boolean; }; }) => {
    const { checked } = evt.target;
    setFieldValue(name, checked);
  };

  const configCheckbox = {
    ...field,
    onChange: handleChange
  };

  const configFormControl:any = {};
  if (meta && meta.touched && meta.error) {
    configFormControl.error = true;
  }

  return (
    <FormControl {...configFormControl}>
      
      <FormGroup>
        <FormControlLabel
          control={<Checkbox color={color} icon={<CheckBoxOutlineBlankOutlinedIcon color={color} />} checkedIcon={<CheckBoxOutlinedIcon />} {...configCheckbox} />}
          label={label}
        />
      </FormGroup>
      {configFormControl.error &&
      <FormLabel className="fs-12 MuiFormHelperText-root" component="legend">{error}</FormLabel>
      }
    </FormControl>
  );
};

export default CheckboxWrapper;
